import React from 'react';
import Footer from '../nav/footer';
import Menu from '../nav/menu';
import { useNavigate } from "react-router-dom";

 /* eslint-disable react/prop-types */
function NotFoundDesktop(props) {
    const navigate = useNavigate();
    let pageText = "The Page you are looking is Not Found";

    let mainDivStyle = {
        position: "absolute",
        top: "85%", 
        left: "45%", 
        fontSize: "xx-large", 
        color: "white"
    }
    if (props && props.isMoreThen2k) {
        mainDivStyle.fontSize = "xx-large";
    }

    if (props && props.message) {
        pageText = props.message;
    }
    return (
        <div>         
            <Menu/>
                <div onClick={() => navigate("/")} style={{ backgroundColor: "#3B776D", display: "flex", justifyContent: "center", position: "relative" }}>
                    <div style={ mainDivStyle }>
                        <span>{pageText}</span>
                    </div>
                    <img src='/img/defaultScreen.jpg' alt=''/>
                    
                </div>
            <Footer/>
        </div>
    )

}

export default NotFoundDesktop;
